import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './TagManagementTabMainNavbar.scss';

const TagManagementTabMainNavbar = (props) => {
  const { onSubmit, tagTabMainPreview } = props;

  return (
    <FixedBottomNavBar className="tag-management-tab-main-navbar">
      <div className="button-group">
        <div className="left">
          <Button color="light" text="미리보기" onClick={tagTabMainPreview} />
        </div>

        <div className="right">
          <Button color="primary" text="저장" onClick={onSubmit} />
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default TagManagementTabMainNavbar;
